import { useState } from "react";

import { SectionDropdown } from "../../../../components/common/SectionDropdown";
import type { IRAOnboardingProps } from "..";
import { SavedInput } from "./SavedInput";
import { SupportLink } from "./SupportLink";

export interface ResidencyVisaStatusProps {
  tradeAccountDetails: IRAOnboardingProps["tradeAccountDetails"];
}

export const ResidencyVisaStatus = ({
  tradeAccountDetails,
}: ResidencyVisaStatusProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onToggleOpen = () => setIsOpen((isOpen) => !isOpen);

  return (
    <SectionDropdown
      title="Residency & Visa Status"
      icon={<SupportLink />}
      isOpen={isOpen}
      onToggleOpen={onToggleOpen}
      className="rounded-lg border border-gray-200 bg-white p-4"
    >
      <div className="flex flex-col">
        <SavedInput
          label="Permanent resident or green card holder of the US"
          value={tradeAccountDetails.permanent_resident ? "Yes" : "No"}
        />
        <SavedInput
          label="USA visa holder"
          value={tradeAccountDetails.visa_type ? "Yes" : "No"}
        />
        <SavedInput
          label="Country of Citizenship"
          value={tradeAccountDetails.country_of_citizenship}
        />
        {tradeAccountDetails.visa_type && (
          <>
            <SavedInput
              label="Visa Type"
              value={tradeAccountDetails.visa_type}
            />
            {/* Visa Number does not exist */}
            {/* <SavedInput label="Visa Number" value={tradeAccountDetails.visa_number} /> */}
            <SavedInput
              label="Visa Expiration"
              value={
                tradeAccountDetails?.visa_expiration_date
                  ? String(tradeAccountDetails.visa_expiration_date)
                  : "-"
              }
            />
          </>
        )}
      </div>
    </SectionDropdown>
  );
};
